import { render, staticRenderFns } from "./LocationsQuickSummary.vue?vue&type=template&id=e5d59176&scoped=true&"
import script from "./LocationsQuickSummary.vue?vue&type=script&lang=js&"
export * from "./LocationsQuickSummary.vue?vue&type=script&lang=js&"
import style0 from "./LocationsQuickSummary.vue?vue&type=style&index=0&id=e5d59176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d59176",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
